export default __webpack_public_path__ + "media/zurb/img/blog/blogpost-hero-screenshot-0f00ac0a86d1b39c0001884101475934.png";